<template>
  <div>
    <LoadOverlay :absolute="true" :activate="page_items == null"></LoadOverlay>

    <v-container>
      <v-row>
        <v-col cols="12" v-for="(item, index) in page_items" :key="index">
          <slot name="view_item" :item="item"></slot>
        </v-col>
      </v-row>
    </v-container>
    <v-pagination
      v-if="pages > 1"
      v-model="current_page"
      :length="pages"
      :total-visible="total_visible"
    ></v-pagination>
  </div>
</template>
<script>
import LoadOverlay from "@/components/helpers/LoadOverlay.vue";

export default {
  props: ["pages", "items_per_page", "total_visible", "get_page_items"],
  components: { LoadOverlay },
  data() {
    return {
      current_page: 1,
    };
  },
  methods: {},
  watch: {},
  computed: {
    page_items() {
      return this.get_page_items(this.current_page);
    },
  },
};
</script>
